import React, { useState, useEffect, useCallback } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { ContentTitle, RightGrid } from '../ui/styled';
import { Auth } from 'aws-amplify';
import BackIcon from '../common/Back/BackIcon';
import PageHeading from '../common/Heading/PageHeading';
import CommonSearch from '../common/Search/CommonSearch';
import { commonQueryParams } from '../../services/QueryParams/QueryParams';
import { LeftGrid } from '../Episode/Episode.Styled';
import { paginationSize, REPORT_LIST_URL } from '../../constants';
import { useDispatch } from 'react-redux';
import { getReportList } from './services/reportsApi';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import ReportDialog from './ReportDialog/ReportDialog';
import {
  getReportDetail,
  resetReportDetail,
  setReportForm,
} from '../../redux/report/reportForm/reportSlice';

const ReportList = (props) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [searchReportList, setSearchReportList] = useState('');
  const [openReportDialog, setOpenReportDialog] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [reportList, setReportList] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
    sortModel: '',
  });

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    reportList.pageSize,
    reportList.page,
    reportList.sortModel,
    searchReportList,
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const QuickSearchToolbar = () => {
    return (
      <CommonSearch
        searchText={searchReportList}
        setSearchText={setSearchReportList}
      />
    );
  };

  const fetchData = async () => {
    setReportList((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = commonQueryParams(
      REPORT_LIST_URL,
      searchReportList,
      reportList
    );
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const reports = await getReportList({
      commonParams,
      authorization,
    });
    setReportList((prveState) => ({
      ...prveState,
      ...reports,
    }));
  };

  const handleSortModelChange = useCallback((sortModel) => {
    // Here you save the data you need from the sort model
    setReportList((prveState) => ({ ...prveState, sortModel: [...sortModel] }));
  }, []);

  const handleReportDialog = (params) => {
    const { row } = params;
    dispatch(getReportDetail(row));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 700);
    setOpenReportDialog(true);
  };

  const handelNewReportForm = () => {
    dispatch(resetReportDetail());
    dispatch(setReportForm(true));
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 700);
    setOpenReportDialog(true);
  };

  const columnsData = [
    {
      field: 'actions',
      headerName: 'Actions',
      width: 80,
      type: 'actions',
      renderCell: (params) => {
        return (
          <IconButton onClick={() => handleReportDialog(params)}>
            <EditIcon />
          </IconButton>
        );
      },
    },
    {
      field: 'rptId',
      headerName: 'Report Id',
      width: 150,
    },
    { field: 'reportTitle', headerName: 'Report Title', flex: 1 },
  ];

  const getReportDialog = () => {
    return (
      <>
        <ReportDialog
          open={openReportDialog}
          setOpen={setOpenReportDialog}
          authToken={user?.signInUserSession.accessToken.jwtToken}
          openBackdrop={openBackdrop}
          fetchData={fetchData}
        />
      </>
    );
  };

  return (
    <>
      <ContentTitle container>
        <RightGrid item xs={12} sm={6}>
          <BackIcon />
          <PageHeading title='Report List' />
        </RightGrid>
        <LeftGrid item xs={12} sm={6}>
          <Button variant='contained' onClick={() => handelNewReportForm()}>
            New Report
          </Button>
        </LeftGrid>
      </ContentTitle>
      <DataGrid
        autoHeight
        getRowHeight={() => 'auto'}
        columns={columnsData}
        rows={reportList.data}
        pageSize={reportList.pageSize}
        page={reportList.page - 1}
        rowCount={reportList.total}
        paginationMode='server'
        sortingMode='server'
        onPageSizeChange={(newPageSize) =>
          setReportList((prveState) => ({
            ...prveState,
            pageSize: newPageSize,
          }))
        }
        onPageChange={(newPage) => {
          setReportList((prveState) => ({ ...prveState, page: newPage + 1 }));
        }}
        rowsPerPageOptions={paginationSize}
        pagination
        components={{ Toolbar: QuickSearchToolbar }}
        experimentalFeatures={{ newEditingApi: true }}
        onSortModelChange={handleSortModelChange}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        loading={reportList.isLoading}
      />
      {getReportDialog()}
    </>
  );
};
export default ReportList;
